import { createContext, useContext } from 'react';

export class ApiMap {
  private map = new Map<string, any>();

  constructor(apis: Record<string, any>) {
    Object.entries(apis).forEach(([apiKey, api]) => this.set(apiKey, api));
  }

  set(apiKey: string, api: any) {
    if (this.map.has(apiKey)) {
      throw new Error(
        `Provider with the key ${apiKey} is already registered. Please, use unique api keys`
      );
    } else {
      this.map.set(apiKey, api);
    }
  }

  has(apiKey: string) {
    return this.map.has(apiKey);
  }

  get<T>(apiKey: string): T | undefined {
    return this.map.get(apiKey);
  }
}

export const ApiContext = createContext<ApiMap>(new ApiMap({}));

// TODO: remove context and hook, create and export instances of api services instead
// https://breezeventures-io.slack.com/archives/C044YBS4CDA/p1684227675633009?thread_ts=1684143646.740569&cid=C044YBS4CDA
export function useApi<T>(key: string): T {
  const apiContext = useContext(ApiContext);

  if (!apiContext.has(key)) {
    throw Error(`Api provider ${key} is missing`);
  }

  return apiContext.get(key) as T;
}
